export default __webpack_public_path__ + "src/components/pages/shared/images/48c06a1842306955e80b42de07840350.png";